(() => {
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduce || !window.gsap || !window.ScrollTrigger) return;

  const gsap = window.gsap;
  gsap.registerPlugin(window.ScrollTrigger);

  const pin = document.querySelector("[data-pin-gallery]");
  if (pin && window.matchMedia("(min-width: 901px)").matches) {
    const side = pin.querySelector("[data-pin-side]");
    const stack = pin.querySelector("[data-pin-stack]");
    const cards = gsap.utils.toArray(pin.querySelectorAll("[data-pin-card]"));
    if (side && stack && cards.length) {
      ScrollTrigger.create({
        trigger: side,
        start: "top 18%",
        endTrigger: stack,
        end: "bottom bottom",
        pin: true,
        pinSpacing: false,
        anticipatePin: 1
      });

      cards.forEach((card) => {
        const media = card.querySelector(".pin-card__media");
        if (!media) return;
        gsap.fromTo(
          media,
          { scale: 0.9, opacity: 0.45 },
          {
            scale: 1,
            opacity: 1,
            ease: "none",
            scrollTrigger: {
              trigger: card,
              start: "top 85%",
              end: "top 32%",
              scrub: true
            }
          }
        );
      });
    }
  }

  document.querySelectorAll("[data-scrub-text]").forEach((root) => {
    const words = root.querySelectorAll("[data-scrub-word]");
    if (!words.length) return;
    gsap.set(words, { opacity: 0.12 });
    gsap.to(words, {
      opacity: 1,
      stagger: 0.06,
      ease: "none",
      scrollTrigger: {
        trigger: root,
        start: "top 78%",
        end: "top 30%",
        scrub: true
      }
    });
  });
})();
